/*
  Animated exclusive accordion for the FAQ.
  Uses the Web Animations API with measured heights: explicit keyframes
  animate reliably even on a freshly-opened <details> subtree (CSS
  transitions there skip the first open). Reduced-motion users get
  instant native toggling with exclusivity preserved.
*/
(function () {
  if (window.__nuvaFaq) return;
  window.__nuvaFaq = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  var DURATION = 320;

  function stopAnimations(wrap) {
    wrap.getAnimations().forEach(function (a) {
      a.cancel();
    });
  }

  function expand(details) {
    var wrap = details.querySelector('.nuva-faq__answer-wrap');
    details.setAttribute('open', '');
    if (!wrap) return;
    stopAnimations(wrap);
    var h = wrap.scrollHeight;
    wrap.style.overflow = 'hidden';
    var anim = wrap.animate(
      [{ height: '0px', opacity: 0.4 }, { height: h + 'px', opacity: 1 }],
      { duration: DURATION, easing: EASE }
    );
    anim.onfinish = anim.oncancel = function () {
      wrap.style.overflow = '';
    };
  }

  function collapse(details) {
    var wrap = details.querySelector('.nuva-faq__answer-wrap');
    if (!wrap) {
      details.removeAttribute('open');
      return;
    }
    stopAnimations(wrap);
    var h = wrap.scrollHeight;
    wrap.style.overflow = 'hidden';
    var anim = wrap.animate(
      [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0.4 }],
      { duration: DURATION, easing: EASE }
    );
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      details.removeAttribute('open');
      wrap.style.overflow = '';
    }
    anim.onfinish = finish;
    window.setTimeout(finish, DURATION + 150); // safety
  }

  function init() {
    document.querySelectorAll('.nuva-faq__list').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var summary = e.target.closest('summary');
        if (!summary || !list.contains(summary)) return;
        var details = summary.closest('[data-nuva-faq-item]');
        if (!details) return;

        if (reduceMotion || !('animate' in Element.prototype)) {
          list.querySelectorAll('[data-nuva-faq-item][open]').forEach(function (other) {
            if (other !== details) other.removeAttribute('open');
          });
          return; // native toggle
        }

        e.preventDefault();
        if (details.hasAttribute('open')) {
          collapse(details);
        } else {
          list.querySelectorAll('[data-nuva-faq-item][open]').forEach(function (other) {
            if (other !== details) collapse(other);
          });
          expand(details);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
